import { render, staticRenderFns } from "./HomeHeading.vue?vue&type=template&id=91db20c4&scoped=true&"
import script from "./HomeHeading.vue?vue&type=script&lang=js&"
export * from "./HomeHeading.vue?vue&type=script&lang=js&"
import style0 from "./HomeHeading.vue?vue&type=style&index=0&id=91db20c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91db20c4",
  null
  
)

export default component.exports